import auth from './auth.json';
import bookings from './bookings.json';
import dashboard from './dashboard.json';
import nutrition from './nutrition.json';
import workoutGoals from './workoutGoals.json';
import walkthrough from './walkthrough.json';
import home from './home.json';
import homeWorkouts from './homeWorkouts.json';
import payments from './payments.json';
import bodyscan from './bodyscan.json';
import strengthAssessment from './strengthAssessment.json';
import familyPlan from './familyPlan.json';
import settings from './settings.json';

export default { auth, bookings, dashboard, nutrition, workoutGoals, walkthrough, familyPlan, home, bodyscan,
strengthAssessment, settings, homeWorkouts, payments };
